import initGrabScroll from './initGrabScroll';

const partnersSection = document.querySelector('#partners-section');

if (partnersSection) {
	initGrabScroll(partnersSection);

	const partnersCarousel = document.getElementById('partners-carousel');
	const partnersPrev = document.getElementById('partners-prev');
	const partnersNext = document.getElementById('partners-next');

	if (partnersCarousel && partnersPrev && partnersNext) {
		const getCardScrollAmount = () => {
			const card = partnersCarousel.querySelector('.partner-card');
			if (!card) return 343;
			const gap =
				parseInt(window.getComputedStyle(partnersCarousel).columnGap, 10) || 24;
			return card.offsetWidth + gap;
		};

		const updateArrows = () => {
			const isAtStart = partnersCarousel.scrollLeft <= 1;
			const isAtEnd =
				partnersCarousel.scrollLeft + partnersCarousel.clientWidth + 1 >=
				partnersCarousel.scrollWidth;
			partnersPrev.classList.toggle('opacity-30', isAtStart);
			partnersNext.classList.toggle('opacity-30', isAtEnd);
		};

		partnersPrev.addEventListener('click', () => {
			partnersCarousel.scrollBy({
				left: -getCardScrollAmount(),
				behavior: 'smooth',
			});
		});

		partnersNext.addEventListener('click', () => {
			partnersCarousel.scrollBy({
				left: getCardScrollAmount(),
				behavior: 'smooth',
			});
		});

		partnersCarousel.addEventListener('scroll', updateArrows);
		updateArrows();
	}
}
